import React from "react";
import { useStoreState } from "easy-peasy";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle } from "@fortawesome/free-solid-svg-icons";
import "../../../assets/layout/banner.css";
import AxiosWrapper from "../../../services/axios";
import Parser from 'react-html-parser';
import { FLOW, PRODUCT } from "../../../models/websiteTypesConstants";

function Banner() {
  const mainSettings = useStoreState(
    (state) => state.siteSettingsModel.mainSettings
  );
  const Flow = useStoreState(
    (state) => state.siteSettingsModel.mainSettings.Flow
  );
  const brandSettings = useStoreState(
    (state) => state.siteSettingsModel.brandSettings
  );
  const productSettings = useStoreState(
    (state) => state.siteSettingsModel.productSettings
  );

  const isPrequal = mainSettings.Flow === FLOW.PREQUAL || mainSettings.Flow === FLOW.PREQUALSTRAIGHT || mainSettings.Flow === FLOW.PREQUALFIT;
  const isPrequalStraight = mainSettings.Flow === FLOW.PREQUALSTRAIGHT;
  const isStandalone = mainSettings.Flow === FLOW.STANDALONE;
  const checkStyle = {
    color: (isPrequal || isStandalone) ? brandSettings.Secondary : "#fff",
    verticalAlign: "top",
  };
  
  const creditLimit = mainSettings?.CreditLimit ?? 0;
  const formattedCreditLimit = creditLimit
    ? `$${Number(creditLimit).toLocaleString()} Credit Limit`
    : null;
  const showCreditLimit = brandSettings.ProductName === PRODUCT.Revel && !!formattedCreditLimit;

  const axios = new AxiosWrapper();
  const bannerbgImageSurgeReflexDesktop = brandSettings.BannerImage.replace(".png", "") + (((isStandalone && ["Reflex", "Revel"].includes(brandSettings.ProductName)) || (isPrequal && brandSettings.ProductName === PRODUCT.Revel)) ? ".png" : ".jpg");
  const bannerbgImageSurgeReflexTablet = brandSettings.BannerImage.replace(".png", "") + "-tablet." + ((brandSettings.ProductName === PRODUCT.Surge) ? "jpg" : "png");
  const bannerbgImageSurgeReflexMobile = brandSettings.BannerImage.replace(".png", "") + "-mobile.png";

  const bannerImg = {
    backgroundColor: isPrequalStraight ? "transparent" : brandSettings.BannerBgColor,
    backgroundImage: (isPrequal || isStandalone) ? `url('${bannerbgImageSurgeReflexDesktop}')` : null,
    backgroundSize: isPrequalStraight ? "cover" : "auto 100%",
    backgroundPosition: isPrequalStraight ? "center top" : "center right",
    backgroundRepeat: "no-repeat",
    minHeight: isPrequalStraight ? "450px" : "auto"
  };

  const bannerImgMobileSurge = {
    backgroundColor: brandSettings.BannerBgColor,
    backgroundImage: `url('${bannerbgImageSurgeReflexMobile}')`,
    backgroundSize: "cover",
    backgroundRepeatY: "no-repeat",
    backgroundPosition: "center",
    padding : "15px 0 15px 10px"
  };

  const bannerImgMobile = {
    backgroundColor: isPrequalStraight ? "transparent" : ((isStandalone && brandSettings.ProductName === PRODUCT.Reflex) ? null : brandSettings.BannerBgColor),
    backgroundImage: `url('${bannerbgImageSurgeReflexMobile}')`,
    width: "100%",
    height: "auto",
    backgroundSize: isPrequalStraight ? "100% auto" : ((brandSettings.ProductName === PRODUCT.Surge || (brandSettings.ProductName === PRODUCT.Reflex && isStandalone)) ? "110% 100%" : "85%"),
    backgroundRepeat: "no-repeat",
    backgroundPosition: isPrequalStraight ? "center center" : (brandSettings.ProductName === PRODUCT.Surge ? "center center" : ((brandSettings.ProductName === PRODUCT.Reflex && isStandalone) ? "" : "right bottom")),
    padding: isPrequalStraight ? "0" : (brandSettings.ProductName === PRODUCT.Surge ? "16px 0px 16px 10px" : "10px 0px 10px 10px"),
    minHeight: (isStandalone && brandSettings.ProductName === PRODUCT.Reflex) ? "140px" : null,
  };

  const bannerImgTablet = {
    fontFamily: "'Century Gothic', sans-serif",
    fontStyle: "normal",
    backgroundColor: isPrequalStraight ? "transparent" : ((isStandalone && brandSettings.ProductName === PRODUCT.Reflex) ? null : brandSettings.BannerBgColor),
    backgroundImage: (isPrequal || isStandalone) ? `url('${bannerbgImageSurgeReflexTablet}')`: null,
    backgroundSize: isPrequalStraight ? "cover" : ((brandSettings.ProductName === PRODUCT.Surge) ? (Flow === "PREQUAL" ? "auto 90%" : "auto 100%") : ((isStandalone && ["Reflex", "Revel"].includes(brandSettings.ProductName)) ? null : "auto 100%")),
    backgroundPosition: isPrequalStraight ? "center top" : (brandSettings.ProductName === PRODUCT.Surge ? ((getTabletOrientation() === "landscape") ? "right bottom" : ((Flow === "PREQUAL") ? "80px bottom" : "right bottom")) : "right bottom"),
    backgroundRepeat: "no-repeat",
    minHeight: isPrequalStraight ? "350px" : "auto"
  };

  const prequalStraightContentColClass = isPrequalStraight ? "col-lg-7 banner-content" : "col-lg-6 banner-content";
  const prequalStraightContentStyle = isPrequalStraight
    ? {
        paddingLeft: "30px",
        paddingTop: "22px",
        paddingBottom: "22px",
      }
    : {};
  const prequalStraightTitleStyle = isPrequalStraight
    ? {
        maxWidth: "720px",
        lineHeight: "1.15",
        marginTop: "8px",
        marginBottom: "8px",
      }
    : {};

  function getTabletOrientation() {
    // Use a CSS media query to check for landscape orientation
    var landscapeQuery = window.matchMedia("(orientation: landscape)");

    // Return "landscape" if the media query matches
    if (landscapeQuery.matches) {
      return "landscape";
    }
  
    // If landscape query didn't match, assume it's vertical
    return "vertical";
  }

  

  return (
    <div>
      <div
        className={ (brandSettings.ProductName === PRODUCT.Surge && isPrequal) ? "banner-container banner bannerPosition d-none d-xl-block" : "banner-container banner d-none d-lg-block"}
        style={(!axios.isTablet()) ? bannerImg : bannerImgTablet}
      >
        <div className="container mxwidth">
          <div className="d-flex flex-wrap w-100" style={isPrequalStraight ? {alignItems: "center", minHeight: "450px"} : {}}>
            <div
              className={prequalStraightContentColClass}
              style={prequalStraightContentStyle}
            >
              <div className="row">
                <h1 className={(!isPrequal && !isStandalone) ? "bannerTextTitle mb-3 mt-3" : "bannerTextTitle"} style={{
                  fontSize : isPrequalStraight ? "65px" : ((!isPrequal && !isStandalone) ? "47px" : "60px"),
                  color: isPrequalStraight ? "#000" : "",
                  textAlign: isPrequalStraight ? "left" : "",
                  ...prequalStraightTitleStyle
                }}>
                  {Parser(productSettings.BannerText.Title)}
                </h1>
                <h4 className="bannerTextSubtitle">
                  {productSettings.BannerText.SubTitle}
                </h4>
                {showCreditLimit && (
                  <h4 className="bannerTextSubtitle bannerCreditLimit">
                    {formattedCreditLimit}
                  </h4>
                )}
              </div>
              <div className="row">
                <table className={(isPrequal && brandSettings.ProductName === PRODUCT.Revel) ? "col-lg-8" : "col-lg-12"}>
                  <tbody>
                    {productSettings.BannerText.Description.length > 0 && productSettings.BannerText.Description.map((i, j) => {
                      return (
                        <tr key={j}>
                          <td className="check align-top" style={checkStyle}>
                            <img src="/checkmark.png" alt="checkmark" />
                          </td>
                          <td>
                            <p className="bannerTextDescription">{i.Text}</p>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
              <div className="row">
                <div className={ (!isPrequal && !isStandalone) ? "col-lg-12" : "col-lg-6 small"}>
                  <span className="artNotation" style={{fontSize : (!isPrequal && !isStandalone) ? "13px" : ""}}>
                    {productSettings.BannerText.Note}
                  </span>
                </div>
              </div>
            </div>
            <div className={isPrequalStraight ? "d-none" : "col-lg-6 align-self-center small"}>
              {(isPrequal || isStandalone) ? null : (
                <div className="card-image-container p-0 text-center w-50">
                  <img alt="" src={brandSettings.CardImage} className="col-lg-12"/>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div
        className={ (brandSettings.ProductName === PRODUCT.Surge && isPrequal) ? "banner-container banner bannerPosition d-none d-sm-block d-xl-none" : "banner-container banner d-none d-sm-block d-lg-none"}
        style={bannerImgTablet}
      >
        <div className="container paddingtablet" style={{maxWidth : "unset"}}>
          <div className="row" style={isPrequalStraight ? {alignItems: "center", minHeight: "350px"} : {}}>
            <div
              className={isPrequalStraight ? "col-7 banner-content" : "col-8 banner-content"}
              style={isPrequalStraight ? {paddingTop: "12px", paddingBottom: "12px"} : {}}
            >
              <div className="row">
                <h1 className="bannerTextTitle" style={{
                  color: isPrequalStraight ? "#000" : "",
                  textAlign: isPrequalStraight ? "left" : "",
                  ...(isPrequalStraight ? { maxWidth: "95%", lineHeight: "1.15" } : {})
                }}>
                  {Parser(productSettings.BannerText.Title)}
                </h1>
                <h4 className="bannerTextSubtitle">
                  {productSettings.BannerText.SubTitle}
                </h4>
                {showCreditLimit && (
                  <h4 className="bannerTextSubtitle bannerCreditLimit">
                    {formattedCreditLimit}
                  </h4>
                )}
              </div>
              <div className="row">
                <table className="col-8">
                  <tbody>
                    {productSettings.BannerText.Description.length > 0 && productSettings.BannerText.Description.map((i, j) => {
                      return (
                        <tr key={j}>
                          <td className="check align-top" style={checkStyle}>
                            <img src="/checkmark.png" alt="checkmark" />
                          </td>
                          <td>
                            <p className="bannerTextDescription">{i.Text}</p>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
                <span className={ isPrequal  || isStandalone ? "col-8 mt-2 artNotation" : "col-12 mt-2 artNotation"}>
                  {productSettings.BannerText.Note}
                </span>
              </div>
            </div>
            <div className="col-4 p-0 align-self-center small">
              {(isPrequal || isStandalone) ? null : (
                <div className="card-image-container p-0 text-center">
                  <img className="w-100" alt="Brand Card" src={brandSettings.CardImage}/>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="banner-container d-block d-sm-none">
        {(isPrequal || isStandalone) ? (
          <>
            {isPrequalStraight ? (
              showCreditLimit ? (
                <div className="banner-mobile" style={{
                  position: "relative",
                  padding: "0",
                  margin: "0",
                  backgroundImage: `url('${bannerbgImageSurgeReflexMobile}')`,
                  backgroundSize: "cover",
                  backgroundPosition: "center top",
                  backgroundRepeat: "no-repeat",
                  minHeight: "129px"
                }}>
                  <div style={{padding: "16px 5%", maxWidth: "50%"}}>
                    <h1 className="bannerTextTitle mb-2" style={{
                      color: "#000",
                      textAlign: "left",
                      lineHeight: "1.1",
                      fontSize: "26px",
                      margin: "0"
                    }}>
                      {productSettings.BannerText.Title}
                    </h1>
                    <h4 className="bannerCreditLimit" style={{
                      color: "#000",
                      textAlign: "left",
                      fontSize: "14px",
                      margin: "4px 0 0"
                    }}>
                      {formattedCreditLimit}
                    </h4>
                  </div>
                </div>
              ) : (
                <div className="banner-mobile" style={{position: "relative", padding: "0", margin: "0"}}>
                  <img
                    src={bannerbgImageSurgeReflexMobile}
                    alt=""
                    style={{width: "100%", height: "auto", display: "block"}}
                  />
                  <div style={{position: "absolute", left: "5%", top: "50%", transform: "translateY(-50%)", maxWidth: "50%"}}>
                    <h1 className="bannerTextTitle mb-2" style={{
                      color: "#000",
                      textAlign: "left",
                      lineHeight: "1.1",
                      fontSize: "26px",
                      margin: "0"
                    }}>
                      {productSettings.BannerText.Title}
                    </h1>
                  </div>
                </div>
              )
            ) : (
              <div className="banner-mobile" style={brandSettings.ProductName === PRODUCT.Surge ? bannerImgMobileSurge : bannerImgMobile}>
                <div className="container">
                  <div className="row">
                    <div className={(brandSettings.ProductName === PRODUCT.Reflex && isStandalone) ? "col-6" : "col-7"}>
                      <h1 className="bannerTextTitle mb-2">
                        {productSettings.BannerText.Title}
                      </h1>
                      {showCreditLimit && (
                        <h4 className="bannerTextSubtitle bannerCreditLimit">
                          {formattedCreditLimit}
                        </h4>
                      )}
                      {isPrequal &&
                      <h4 className="bannerTextSubtitle">
                        {" "}
                        {productSettings.BannerText.Description.length > 0 && productSettings.BannerText.Description[0].Text.replace("*.","")}
                      </h4>
                      }
                    </div>
                  </div>
                </div>
              </div>
            )}
          </>
        ) : (
          <div className="banner" style={bannerImgMobile}>
            <h1 className={mainSettings.Flow === FLOW.CFC ? "bannerTextTitle text-center" : "bannerTextTitle"}>
              {Parser(productSettings.BannerText.Title)}
            </h1>
            {(isPrequal || isStandalone) ? (
              <img alt="" src={isPrequal ? brandSettings.BannerImage.replace(".png", "") + "-mobile.png" : ''} className="col-lg-12"/>
            ) : (
              <div className="card-image-container text-center">
                <img alt="" src={brandSettings.CardImage} className="col-lg-12"/>
              </div>
            )}
          </div>
        )}
        {isPrequal || isStandalone ? (
          <div className="banner-content reverse">
            {isPrequal && 
            <h3>
              <b>See if you pre-qualify</b>
            </h3>}
            <table className="col-lg-8">
              <tbody>
                {productSettings.BannerText.Description.length > 0 && productSettings.BannerText.Description.map((i, j) => {
                  return (
                    <tr key={j}>
                      <td className="check align-top" style={checkStyle}>
                        <FontAwesomeIcon icon={faCircle} />
                      </td>
                      <td>
                        <label>{i.Text}</label>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <div>
              <small>{productSettings.BannerText.Note}</small>
            </div>
          </div>
        ) : (
          <div className="banner-content reverse cfc1">
            <div>
              <small>{productSettings.BannerText.Note}</small>
            </div>
            <div className="text-center pb-3 ">
              <h3>Apply Now</h3>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Banner;
